import { AppViewMode } from 'src/constants/uiConsts';
import { GetStartedWithOtherPortalPage } from 'src/legacy/components/Onboarding/GetStartedWithOtherPortalPage';
import { RouteAction } from 'src/routes/types';

const action: RouteAction = (context) => {
  const isInternalUser = context.portalConfig.viewMode === AppViewMode.INTERNAL;
  const appBrandName =
    isInternalUser || context.isAssemblyDomain ? 'Assembly' : 'Copilot';

  return {
    chunks: ['onboarding-users'],
    ...(isInternalUser
      ? {
          description:
            `Create a new workspace using one of your existing ` +
            `${appBrandName} accounts or create one using a new email.`,
          title: `${appBrandName} | Workspaces`,
        }
      : {}),
    component: <GetStartedWithOtherPortalPage />,
  };
};

export default action;
